import Alert from 'react-bootstrap/Alert';

export default function MessageBox(props) {
  return (
    <div className="container mt-3">
      <Alert variant={props.variant || 'secondary'}>
        {props.children[1] === 'Network Error'
          ? 'Kết nối thất bại. Vui lòng thử lại sau.'
          : props.children}
      </Alert>
    </div>
  );
}
